import React from "react";
import classNames from "classnames";

const CheckboxField = ({
  label,
  id,
  checked,
  onChange,
  onBlur,
  error,
  serverError,
  disabled = false,
  size = "sm",
  ...props
}) => {
  const sizeClasses = classNames({
    "text-[12px]": size === "sm",
    "text-sm": size === "md",
    "text-base": size === "lg",
  });

  const labelClasses = classNames(
    "flex items-center cursor-pointer select-none",
    {
      "opacity-50 cursor-not-allowed": disabled,
    }
  );

  const checkboxContainerClasses = classNames(
    "relative w-5 h-5 border rounded transition-all duration-300",
    {
      "border-gray-300 bg-white": !error && !serverError && !disabled,
      "border-red-500 bg-white": (error || serverError) && !disabled,
      "bg-gray-100 border-gray-200": disabled,
    }
  );

  const checkboxIndicatorClasses = classNames(
    "absolute inset-0 flex items-center justify-center text-white scale-0 transition-transform duration-200",
    {
      "scale-100 bg-primary": checked && !disabled,
      "bg-gray-300": checked && disabled,
    }
  );

  const errorClasses = classNames("text-sm text-red-500 mt-1", {
    "ml-2": true,
  });

  return (
    <div>
      <label htmlFor={id} className={`${labelClasses} ${sizeClasses}`}>
        <input
          type="checkbox"
          id={id}
          name={id}
          checked={checked}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          className="hidden"
          {...props}
        />
        <span className={checkboxContainerClasses}>
          <span className={checkboxIndicatorClasses}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="w-3.5 h-3.5"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </span>
        </span>
        <span className="ml-3 text-sm text-gray-700">{label}</span>
      </label>
      {(error || serverError) && (
        <div className={errorClasses}>{error || serverError}</div>
      )}
    </div>
  );
};

export default CheckboxField;
